import { Divider, Table, Spin, Select } from 'antd'
import { useEffect, useState } from 'react'
import { getGamesByCategory, getTopUser } from 'src/api/game'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { fetchCountryProvider } from 'src/api/authen'
import GameSelect from 'src/components/Search/GameSelect'

const GameLeaderBoard = () => {
  const [gameLoading, setGameLoading] = useState(false)
  const [loading, setLoading] = useState(true)
  const [game, setGame] = useState(undefined)
  const [transformedData, setTransformedData] = useState([])
  const [country, setCountry] = useState('')
  const [countries, setCountries] = useState([])
  const [games, setGames] = useState([])

  const fetchCountry = async () => {
    try {
      const data = await fetchCountryProvider()
      const countryOptions = data.data.map((item) => ({
        label: item.countryName,
        value: item.countryCode,
      }))
      setCountries(countryOptions)

      if (countryOptions.length > 0) {
        setCountry(countryOptions[0].value)
      }
    } catch (error) {
      console.error('Error fetching country data:', error)
    }
  }

  const fetchGame = async (searchValue = '', shouldSetFirst = true) => {
    try {
      setGameLoading(true)
      const data = await getGamesByCategory(0, 10, searchValue)
      const mazeOptions = data.data.map((item) => ({
        label: item.title,
        value: item.id,
      }))
      setGames(mazeOptions)

      if (shouldSetFirst && mazeOptions.length > 0) {
        setGame(mazeOptions[0].value)
      }
    } catch (error) {
      console.error('Error fetching maze s:', error)
    } finally {
      setGameLoading(false)
    }
  }

  const handleCountryChange = (value) => {
    setCountry(value)
  }

  const fetchTopScoresData = async (id, country) => {
    try {
      setLoading(true)
      const response = await getTopUser(id, country)
      const transformedData = response.data
      setTransformedData(transformedData)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCountry()
    fetchGame('', true)
  }, [])

  useEffect(() => {
    if (game && country) {
      fetchTopScoresData(game, country)
    }
  }, [country, game])

  const columns = [
    {
      title: 'Rank',
      dataIndex: 'rank',
      key: 'rank',
    },
    {
      title: 'User Name',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Points',
      dataIndex: 'points',
      key: 'points',
    },
  ]

  return (
    <>
      <Spin spinning={loading}>
        <GameSelect
          value={game}
          style={{ width: '15%', marginLeft: '10px' }}
          onChange={(value) => setGame(value)}
        />

        <Select
          placeholder="Select Country"
          value={country}
          onChange={handleCountryChange}
          options={countries}
          style={{ width: '15%', marginLeft: '10px' }}
        />
        <Divider />
        <DndProvider backend={HTML5Backend}>
          <Table
            dataSource={transformedData}
            columns={columns}
            pagination={false}
          />
        </DndProvider>
      </Spin>
    </>
  )
}

export default GameLeaderBoard
